import { forwardRef, type SVGProps } from 'react';

/**
 * BotIcon — the canonical "agent" glyph used across the app (chat avatars,
 * tool strip for nli/delegate, navigation, badges, etc.).
 *
 * Drawn lucide-style: 24x24 viewBox, `currentColor` stroke, 2px stroke width,
 * with two filled "eye" dots so the bot reads at small sizes (16px+).
 */
export const BotIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  function BotIcon(props, ref) {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
      >
        <circle cx="12.02" cy="11.81" r="10" />
        <rect x="6.02" y="7.81" width="12" height="6" rx="3" ry="3" />
        <circle cx="10" cy="10.81" r="1" fill="currentColor" stroke="none" />
        <circle cx="14.02" cy="10.82" r="1" fill="currentColor" stroke="none" />
      </svg>
    );
  },
);

/**
 * @deprecated Use `BotIcon` instead. Kept as an alias for any straggling
 * imports of the previous name.
 */
export const DelegateIcon = BotIcon;
